import type { PaginatedResponse, PaginationMeta } from '@models/pagination'
import type { Order, OrderFromErpFilters } from '@models/order'
import type { AxiosError } from 'axios'
import { useQuery } from 'react-query'
import ordersApi from './actions'
import { ordersKeys } from './constants'

interface UseErpOrdersProps {
  orders: Order[]
  ordersMap: Map<number, Order>
  pagination: PaginationMeta
}

const selectData = ({
  data,
  pagination,
}: PaginatedResponse<Order>): UseErpOrdersProps => {
  return {
    orders: data,
    ordersMap: new Map(data.map(order => [order.id, order])),
    pagination,
  }
}

const useErpOrders = (filters: OrderFromErpFilters) => {
  const query = useQuery<
    PaginatedResponse<Order>,
    AxiosError,
    UseErpOrdersProps
  >(ordersKeys.erpOrders(filters), () => ordersApi.getErpOrders(filters), {
    select: selectData,
  })

  return query
}

export default useErpOrders
